"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PlaybackStatus;
(function (PlaybackStatus) {
    /**
     * Video is currently paused.
     */
    PlaybackStatus[PlaybackStatus["PAUSED"] = 0] = "PAUSED";
    /**
     * Video is paused, but the player is buffering (for example, on seek when paused).
     */
    PlaybackStatus[PlaybackStatus["PAUSED_BUFFERING"] = 1] = "PAUSED_BUFFERING";
    /**
     * Video is playing.
     */
    PlaybackStatus[PlaybackStatus["PLAYING"] = 2] = "PLAYING";
    /**
     * Video is trying to play, but is buffering.
     * This can happen due to a seek or an insufficient network connectivity speed.
     */
    PlaybackStatus[PlaybackStatus["PLAYING_BUFFERING"] = 3] = "PLAYING_BUFFERING";
    /**
     * Video has ended. Same as paused, but the playhead is at the end of the stream.
     */
    PlaybackStatus[PlaybackStatus["ENDED"] = 4] = "ENDED";
})(PlaybackStatus = exports.PlaybackStatus || (exports.PlaybackStatus = {}));
/**
 * An object that implements [[PlaybackState]] with UI-friendly defaults.
 */
exports.defaultPlaybackState = {
    duration: 0,
    currentTime: 0,
    status: PlaybackStatus.PAUSED,
    playbackRate: 1,
    volume: 1,
    muted: false
};
//# sourceMappingURL=playback-state.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vidi/dist/src/types/playback-state.js
// module id = 1521
// module chunks = 0 1 2 3